/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigScheduleSelect_CustomerFragment = { __typename: 'Customer', id: string, schedules: Array<{ __typename: 'Schedule', id: string, title: string }> };

export type ConfigScheduleSelect_ConfigFragment = { __typename: 'ConfigurationModel', id: string, schedule?: { __typename: 'ConfigSchedule', schedule?: { __typename: 'Schedule', id: string, title: string } | null } | null };

export type ConfigUpdateScheduleMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateScheduleInput;
}>;


export type ConfigUpdateScheduleMutation = { __typename: 'Mutation', configurationUpdateSchedule: { __typename: 'ConfigurationModel', id: string } };

export const ConfigScheduleSelect_CustomerFragmentDoc = gql`
    fragment ConfigScheduleSelect_customer on Customer {
  id
  schedules {
    id
    title
  }
}
    `;
export const ConfigScheduleSelect_ConfigFragmentDoc = gql`
    fragment ConfigScheduleSelect_config on ConfigurationModel {
  id
  schedule {
    schedule {
      id
      title
    }
  }
}
    `;
export const ConfigUpdateScheduleDocument = gql`
    mutation ConfigUpdateSchedule($input: ConfigurationUpdateScheduleInput!) {
  configurationUpdateSchedule(input: $input) {
    id
  }
}
    `;
export type ConfigUpdateScheduleMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateScheduleMutation, ConfigUpdateScheduleMutationVariables>;

/**
 * __useConfigUpdateScheduleMutation__
 *
 * To run a mutation, you first call `useConfigUpdateScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateScheduleMutation, { data, loading, error }] = useConfigUpdateScheduleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateScheduleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateScheduleMutation, ConfigUpdateScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateScheduleMutation, ConfigUpdateScheduleMutationVariables>(ConfigUpdateScheduleDocument, options);
      }
export type ConfigUpdateScheduleMutationHookResult = ReturnType<typeof useConfigUpdateScheduleMutation>;
export type ConfigUpdateScheduleMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateScheduleMutation>;
export type ConfigUpdateScheduleMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateScheduleMutation, ConfigUpdateScheduleMutationVariables>;